import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, vModelRadio as _vModelRadio, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withModifiers as _withModifiers, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "editGroupAlumnus",
  tabindex: "-1",
  "aria-labelledby": "editGroupAlumnus",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-lg" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = {
  class: "modal-title w-100 text-center fw-bold",
  id: "editGroupAlumnus"
}
const _hoisted_6 = { class: "col-md-12 col-lg-10 row m-0 py-3" }
const _hoisted_7 = { class: "w-max-content col-lg-4 col-form-label fw-bold" }
const _hoisted_8 = { class: "col-lg-8" }
const _hoisted_9 = { class: "col-md-12 col-lg-10 row m-0 py-3" }
const _hoisted_10 = { class: "w-max-content col-lg-4 fw-bold" }
const _hoisted_11 = { class: "col-lg-8 d-flex fs-7 mx-0" }
const _hoisted_12 = { class: "me-2" }
const _hoisted_13 = { class: "col-md-12 col-lg-10 row m-0 py-3" }
const _hoisted_14 = { class: "w-max-content col-lg-4 col-form-label fw-bold" }
const _hoisted_15 = { class: "col-md-12 col-lg-10 row m-0 py-3" }
const _hoisted_16 = { class: "w-max-content col-lg-2 col-form-label fw-bold" }
const _hoisted_17 = { class: "col-lg-2 w-max-content col-form-label" }
const _hoisted_18 = { class: "col-lg-6 d-flex" }
const _hoisted_19 = { class: "form-check me-3 my-auto" }
const _hoisted_20 = ["for"]
const _hoisted_21 = ["id"]
const _hoisted_22 = { class: "form-check my-auto" }
const _hoisted_23 = ["for"]
const _hoisted_24 = ["id"]
const _hoisted_25 = { class: "d-flex justify-content-center modal-footer" }
const _hoisted_26 = {
  class: "modal fade",
  id: "confirmModalAlumnus",
  tabindex: "-1",
  "aria-labelledby": "confirmModalAlumnus",
  "aria-hidden": "true"
}
const _hoisted_27 = { class: "modal-dialog modal-lg" }
const _hoisted_28 = { class: "modal-content" }
const _hoisted_29 = { class: "modal-header" }
const _hoisted_30 = {
  class: "modal-title text-center fw-bold w-100",
  id: "confirmModal"
}
const _hoisted_31 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, null, -1)
const _hoisted_32 = { class: "modal-body" }
const _hoisted_33 = { class: "row mb-3 py-3 px-3 px-md-5 border-bottom" }
const _hoisted_34 = { class: "col-lg-3 fw-bold" }
const _hoisted_35 = { class: "col-lg-8" }
const _hoisted_36 = { class: "text-break break-spaces" }
const _hoisted_37 = { class: "row my-3 py-3 px-3 px-md-5 border-bottom" }
const _hoisted_38 = { class: "w-max-content col-lg-3 fw-bold" }
const _hoisted_39 = { class: "col-lg-7 d-flex fs-7" }
const _hoisted_40 = { class: "me-2" }
const _hoisted_41 = { class: "row my-3 py-3 px-3 px-md-5 border-bottom" }
const _hoisted_42 = { class: "col-lg-3 fw-bold" }
const _hoisted_43 = { class: "row px-3 px-md-5" }
const _hoisted_44 = { class: "col-lg-3 fw-bold" }
const _hoisted_45 = { class: "col-lg-8" }
const _hoisted_46 = { class: "text-break break-spaces" }
const _hoisted_47 = { class: "modal-footer d-flex justify-content-center" }
const _hoisted_48 = {
  class: "modal fade",
  id: "editGroupSuccessAlumnus",
  tabindex: "-1",
  "aria-labelledby": "editGroupSuccessAlumnus",
  "aria-hidden": "true"
}
const _hoisted_49 = { class: "modal-dialog" }
const _hoisted_50 = { class: "modal-content" }
const _hoisted_51 = { class: "modal-header" }
const _hoisted_52 = {
  class: "modal-title text-center fw-bold w-100",
  id: "confirmModal"
}
const _hoisted_53 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, null, -1)
const _hoisted_54 = { class: "" }
const _hoisted_55 = { class: "text-center my-4" }
const _hoisted_56 = { class: "d-flex justify-content-center modal-footer" }

import { translate } from '@/languages/i18n'
import Button from '@/components/button/index.vue'
import Status from '@/components/status/index.vue'
import UserAliasIcon from '@/components/user-alias-icon'

//validate
import useVuelidate from '@vuelidate/core'
import { required } from '@vuelidate/validators'
//constant
// import { DEFAULT_MIN_LENGTH } from '@/constants/number'
import { computed, onMounted, ref, watchEffect } from 'vue'
import groupsService from '@/services/groups.service'
import { useStore } from 'vuex'
import { GROUPS_STORE } from '@/store/constants'
import { useRoute } from 'vue-router'
import TargetTag from '@/components/target-tag/index.vue'
import { ReplayName } from '@/constants/common.ts'
import { Modal } from 'bootstrap'


export default /*#__PURE__*/_defineComponent({
  props: {
  groupId: String,
  dataDetail: Object,
},
  setup(__props) {

const props = __props

const editFailed = ref<boolean>(false)
const store = useStore()
const loadingEdit = ref<boolean>(false)



const rules = computed(() => {
  return {
    published: { required },
  }
})

const formData = ref({
  name: '',
  information: '',
  published: true,
})
const author = ref({})
const dataDefault = ref({})
const loading = ref<boolean>(false)

watchEffect(() => {
  if (props.groupId) {
    loading.value = true
    formData.value = {
      name: props.dataDetail?.name,
      information: props.dataDetail?.information,
      published: props.dataDetail?.published,
    }
    author.value = props.dataDetail?.admin
    dataDefault.value = {
      name: props.dataDetail?.name,
      information: props.dataDetail?.information,
      published: props.dataDetail?.published,
    }
    setTimeout(() => {
      loading.value = false
    }, 500)
  }
})

const v$ = useVuelidate(rules, formData)
const route = useRoute()

const onSubmit = (): void => {
  v$.value.$touch()

  if (v$.value.$invalid) {
    return
  }
}
// 2022/09/15 TienNV Fix double click button confirm edit
const modalConfirm = ref()
const modalSuccess = ref()

onMounted(() => {
  modalConfirm.value = new Modal(document.getElementById('confirmModalAlumnus'))
  modalSuccess.value = new Modal(document.getElementById('editGroupSuccessAlumnus'))
})

const editGroup = async (): void => {
  loadingEdit.value = true
  try {
    const response = await groupsService.editGroupApi(props.groupId, { published: formData.value.published, create_by_admin: true })
    if (response?.status === 200) {
      editFailed.value = false
      store.dispatch(GROUPS_STORE.ACTIONS.SET_LIST_GROUPS, {
        id: route.params?.id,
        params: {
          group_type: '3',
          ...route.query,
          page_of_number: route.query?.page_of_number || 30,
          published: route.query?.published ? '' : true,
          create_by_admin: true,
        },
      })
      dataDefault.value = formData.value
    } else {
      editFailed.value = true
    }
    //2022/09/15 TienNV Fix double click button confirm edit
    modalConfirm.value.hide()
    modalSuccess.value.show()
    setTimeout(() => {
      loadingEdit.value = false
    }, 2000)
  } catch (error) {
    loadingEdit.value = false
    console.log(error)
    editFailed.value = true
    modalConfirm.value.hide()
    modalSuccess.value.show()
  }
}
const resetData = async () => {
  formData.value = {
    name: dataDefault.value?.name,
    information: dataDefault.value?.information,
    published: dataDefault.value?.published,
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("h5", _hoisted_5, _toDisplayString(_unref(translate)('groupEditting')), 1),
            _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close",
              onClick: resetData
            })
          ]),
          _createElementVNode("form", {
            onSubmit: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["prevent"])),
            class: "row mx-0 d-flex justify-content-center"
          }, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("label", _hoisted_7, _toDisplayString(_unref(translate)('groupName')), 1),
              _createElementVNode("div", _hoisted_8, _toDisplayString(formData.value.name), 1)
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("label", _hoisted_10, _toDisplayString(_unref(translate)('creator')), 1),
              _createElementVNode("div", _hoisted_11, [
                _createVNode(_unref(UserAliasIcon), {
                  userType: author.value?.user_type
                }, null, 8, ["userType"]),
                _createElementVNode("p", _hoisted_12, _toDisplayString(author.value?.management_no), 1),
                _createElementVNode("span", null, _toDisplayString(_unref(ReplayName)(author.value?.is_deleted_in_30_days, author.value?.available, author.value?.family_name, author.value?.given_name, author.value?.user_type)) + " " + _toDisplayString(author.value?.user_type == 2 && [0, 1].includes(author.value?.is_deleted_in_30_days) ? `（ ${author.value?.display_name} ）` : ''), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("label", _hoisted_14, _toDisplayString(_unref(translate)('explanatoryText')), 1),
              _createVNode(TargetTag, {
                data: formData.value.information,
                className: 'col-lg-8'
              }, null, 8, ["data"])
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("label", _hoisted_16, _toDisplayString(_unref(translate)('publicSettings')), 1),
              _createElementVNode("div", _hoisted_17, [
                _createVNode(Status)
              ]),
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("label", {
                    class: "form-check-label d-flex",
                    for: _ctx.public
                  }, [
                    _withDirectives(_createElementVNode("input", {
                      class: "form-check-input",
                      type: "radio",
                      name: "flexRadioDefault",
                      id: _ctx.public,
                      value: true,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(v$).published.$model) = $event))
                    }, null, 8, _hoisted_21), [
                      [_vModelRadio, _unref(v$).published.$model]
                    ]),
                    _createTextVNode(" " + _toDisplayString(_unref(translate)('public')), 1)
                  ], 8, _hoisted_20)
                ]),
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("label", {
                    class: "form-check-label d-flex",
                    for: _ctx.private
                  }, [
                    _withDirectives(_createElementVNode("input", {
                      class: "form-check-input",
                      type: "radio",
                      name: "flexRadioDefault",
                      id: _ctx.private,
                      value: false,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(v$).published.$model) = $event))
                    }, null, 8, _hoisted_24), [
                      [_vModelRadio, _unref(v$).published.$model]
                    ]),
                    _createTextVNode(" " + _toDisplayString(_unref(translate)('private')), 1)
                  ], 8, _hoisted_23)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_25, [
              _createVNode(Button, {
                title: _unref(translate)('cancel'),
                type: 'secondary',
                onClick: resetData,
                class: "button-confirm-modal",
                "data-bs-dismiss": "modal",
                className: 'fw-bold'
              }, null, 8, ["title"]),
              _createVNode(Button, {
                title: _unref(translate)('confirm'),
                type: 'secondary',
                onClick: onSubmit,
                dataBsToggle: !_unref(v$).$invalid ? 'modal' : '',
                "data-bs-target": '#confirmModalAlumnus',
                className: 'fw-bold'
              }, null, 8, ["title", "dataBsToggle"])
            ])
          ], 32)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_26, [
      _createElementVNode("div", _hoisted_27, [
        _createElementVNode("form", {
          onSubmit: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["prevent"]))
        }, [
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("h5", _hoisted_30, _toDisplayString(_unref(translate)('groupEditting')), 1),
              _hoisted_31
            ]),
            _createElementVNode("div", _hoisted_32, [
              _createElementVNode("div", _hoisted_33, [
                _createElementVNode("div", _hoisted_34, _toDisplayString(_unref(translate)('groupName')), 1),
                _createElementVNode("div", _hoisted_35, [
                  _createElementVNode("p", _hoisted_36, _toDisplayString(formData.value.name), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_37, [
                _createElementVNode("label", _hoisted_38, _toDisplayString(_unref(translate)('creator')), 1),
                _createElementVNode("div", _hoisted_39, [
                  _createVNode(_unref(UserAliasIcon), {
                    userType: author.value?.user_type
                  }, null, 8, ["userType"]),
                  _createElementVNode("p", _hoisted_40, _toDisplayString(author.value?.management_no), 1),
                  _createElementVNode("span", null, _toDisplayString(_unref(ReplayName)(author.value?.is_deleted_in_30_days, author.value?.available, author.value?.family_name, author.value?.given_name, author.value?.user_type)) + _toDisplayString(author.value?.user_type == 2 && [0, 1].includes(author.value?.is_deleted_in_30_days) ? `（ ${author.value?.display_name} ）` : ''), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_41, [
                _createElementVNode("div", _hoisted_42, _toDisplayString(_unref(translate)('explanatoryText')), 1),
                _createVNode(TargetTag, {
                  data: formData.value.information,
                  className: 'col-lg-8'
                }, null, 8, ["data"])
              ]),
              _createElementVNode("div", _hoisted_43, [
                _createElementVNode("div", _hoisted_44, _toDisplayString(_unref(translate)('publicSettings')), 1),
                _createElementVNode("div", _hoisted_45, [
                  _createElementVNode("p", _hoisted_46, _toDisplayString(formData.value.published ? _unref(translate)('public') : _unref(translate)('private')), 1)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_47, [
              _createVNode(Button, {
                title: _unref(translate)('titleButtonEdit'),
                type: 'secondary',
                dataBsToggle: 'modal',
                dataBsTarget: '#editGroupAlumnus',
                class: "me-lg-3",
                className: 'fw-bold'
              }, null, 8, ["title"]),
              _createVNode(Button, {
                title: _unref(translate)('update'),
                type: 'secondary',
                loading: loadingEdit.value,
                disabled: loadingEdit.value,
                onClick: editGroup,
                className: 'fw-bold'
              }, null, 8, ["title", "loading", "disabled"])
            ])
          ])
        ], 32)
      ])
    ]),
    _createElementVNode("div", _hoisted_48, [
      _createElementVNode("div", _hoisted_49, [
        _createElementVNode("div", _hoisted_50, [
          _createElementVNode("div", _hoisted_51, [
            _createElementVNode("h5", _hoisted_52, _toDisplayString(_unref(translate)('groupEditting')), 1),
            _hoisted_53
          ]),
          _createElementVNode("div", _hoisted_54, [
            _createElementVNode("p", _hoisted_55, _toDisplayString(editFailed.value ? _unref(translate)('errorEditGroup') : _unref(translate)('OD47updateComplete')), 1)
          ]),
          _createElementVNode("div", _hoisted_56, [
            _createVNode(Button, {
              title: _unref(translate)('close'),
              type: 'secondary',
              "data-bs-dismiss": "modal",
              className: 'fw-bold'
            }, null, 8, ["title"])
          ])
        ])
      ])
    ])
  ], 64))
}
}

})